<section (mouseleave)="dismissPopover()">
  <ng-container *ngFor="let item of data">
    <div class="dropdown-group">
      <ion-label (click)="linkToPage(item)">
        {{ item.title }}
      </ion-label>
    </div>
  </ng-container>
</section>
